export default {
  mfa2: {
    0: "多要素認証（MFA）は、シンプルで効果的なセキュリティのベストプラクティス手法であり、ユーザー名とパスワードを超えたセキュリティの追加レイヤーを追加します。 例えば、銀行やオフサイトログイン用の U-Shield では、携帯電話の SMS 認証が必要になります。",
    1: "さまざまな顧客のシナリオやセキュリティニーズに応じて、複数の方法で多要素二次認証ログインをサポートします。",
    2: "Authing は WeChat アプリ「端末動的認証」機能を持っています。 アプリから送信された動的パスワードを携帯電話から受信することで、「多要素認証」の目的を達成し、アカウントのセキュリティ要素を99.99％に高めることができます。",
    3: "各ユーザーのログインのセキュリティレベルをインテリジェントに認識し、それに基づいて異なるログインポリシーを設定します。",
    4: "人、役割、部署ごとに二次認証ルールを設定します。",
    5: "アプリケーションの重要度に応じて、必要に応じて異なるアプリケーションの二次検証開始ルールを設定します。",
    6: "1954年5月に設立された高等教育出版社は、新中国で最も早い時期に設立された専門的な教育出版機関の一つです。 1700人以上のスタッフを擁し、年間1万冊以上の書籍を発行し、発行部数は1億3000万部。",
    7: "多要素認証 MFA - ダイナミック・トークン、二要素認証 - Authing",
    多因素认证: "多要素認証",
    免费使用: "無料アクセス",
    查看文档: "ドキュメントを見る",
    不同种类的认证因素: "さまざまなタイプの認証要素",
    问题校验: "問題点のチェック",
    问题验证: "問題の検証",
    密码验证: "パスワード確認",
    物理校验: "物理的な検証",
    一次性密码: "ワンタイム パスワード",
    二维码扫描: "QR コード スキャン",
    APP验证推送: "APP 検証",
    生物校验: "生物的な検証",
    指纹验证: "指紋認証",
    面部验证: "顔認証",
    虹膜验证: "虹彩の検証",
    AuthingMFA的优势: "Authing MFA のメリット",
    前往社区: "コミュニティへ",
  },
  mfa: {
    banner: {
      title: "多要素認証",
      subtitle:
        "多要素認証（MFA）は、シンプルで効果的なセキュリティのベストプラクティス手法であり、ユーザー名とパスワードを超えたセキュリティの追加レイヤーを追加します。 例えば、銀行やオフサイトログイン用の U-Shield では、携帯電話の SMS 認証が必要になります。",
    },
    type: {
      title: "さまざまなタイプの認証要素",
      "item-one": {
        title: "問題点のチェック",
        "list-one": "問題の検証",
        "list-two": "パスワード確認",
      },
      "item-two": {
        title: "物理的な検証",
        "list-one": "ワンタイム パスワード",
        "list-two": "QR コード スキャン",
        "list-three": "APP 検証",
      },
      "item-three": {
        title: "生物的な検証",
        "list-one": "指紋認証",
        "list-two": "顔認証",
        "list-three": "虹彩の検証",
      },
    },
    advance: {
      title: "Authing MFA のメリット",
      "descript-one":
        "Authing は WeChat アプリ「端末動的認証」機能を持っています。 アプリから送信された動的パスワードを携帯電話から受信することで、「多要素認証」の目的を達成し、アカウントのセキュリティ要素を99.99％に高めることができます。",
      "descript-two":
        "各ユーザーのログインのセキュリティレベルをインテリジェントに認識し、それに基づいて異なるログインポリシーを設定します,人、役割、部署ごとに二次認証ルールを設定します,アプリケーションの重要度に応じて、必要に応じて異なるアプリケーションの二次検証開始ルールを設定します。",
    },
  },
  sso: {
    banner: {
      "title-one": "サインイン",
      "title-two": "一度だけ",
      subtitle:
        "シングルサインオン（SSO）は、企業システムを統合するためのソリューションの一つで、ユーザーが相互に信頼されたすべてのアプリケーションにアクセスするために一度だけログインする必要がある複数のアプリケーションのために設計されています。",
    },
    platform: {
      title: "Authing SSO プラットホーム",
      "descript-one":
        "シングルサインオン技術により、顧客は開発を行うことなく、アイデンティティ権限を統一的に制御しながら、あらゆるソフトウェアサービスに1カ所からアクセスすることができます。",
      "descript-two":
        "開発者であれば、Authing は、OAuth2、OIDC、SAML、LDAP などの任意のプロトコルを介したログインカスタマイズのための簡単なシングルサインオンもサポートしており、統一されたユーザープールと最小5行のコードで利用できます。",
    },
    scene: {
      title: "さまざまなシナリオでのシングルサインオン アプリケーション",
      "item-one": {
        title: "内部従業員のステータス",
        "descript-one":
          "パーミッションの厳密な制御：アイデンティティ管理ソリューションは、ユーザーのさまざまなアクセスレベルを簡単に制御する方法を提供します。 社員が入社したり、昇進したりしたときに、異なるアプリケーションの権限を簡単に割り当て、変更することができます。 また、企業は、従業員が退職する際に、すべての異なるプラットフォームへのアクセスを簡単に取り消したり、取り消したりすることもできます。",
        "descript-two":
          "Efficient Office: Authing は、企業向けにワンストップのチームアプリケーションプラットフォームを提供し、メンバーやパートナーがローカルまたはクラウドベースのソフトウェアサービスに1か所からアクセスし、アクセス権を一元管理できるようにすることで、効率的なオフィスを実現し、人事・IT 管理を簡素化し、ビジネスの成長を加速させます。",
        "descript-three":
          "簡単な統合：あらゆる企業システムとの統合が可能なだけでなく、Amazon、高等教育出版社、南東部の大学、その他の素晴らしい企業など、幅広い業界に適した技術を見つけるのに役立つ何千もの統合アプリケーションをまとめ、IT 管理をより複雑にしないようにします。",
      },
      "item-two": {
        title: "外部ユーザーID",
        "descript-one":
          "事業展開の推進：どのようなブラウザでも、どのようなデバイスでも、Authing はクロスプラットフォームで、エンドユーザーに差別化されていないシングルサインオン体験を提供します。",
        "descript-two":
          "機会を分析する: Authing を使用して、異なる ID ソースからの複数のユーザーデータを統合します。 一度感作されれば、企業はこのデータを利用してマーケティングや販売機会を効果的に推進することができます。",
        "descript-three":
          "ゴーライブの高速化：Authing は、登録とログインを最適化するための直感的なログインインターフェースを提供し、設計サイクルを劇的に短縮し、マーケティングリソースを節約し、ビジネスアプリケーションの迅速なゴーライブを可能にします。",
      },
      "item-tree": {
        title: "为你的客户开发",
        "descript-one":
          "お客様の成功を達成することが私たちの目標です。 企業のデジタル化が進むにつれ、あらゆる政府や企業が複数のソフトウェア技術を使用したり、開発したりしています。 プラットフォームや技術に関係なく、Authing のドキュメントと SDK を使用することで、認証と認可のためのシングルサインオンを迅速に統合することができます。",
      },
    },
    advance: {
      title: "Authing SSO のメリット",
      subtitle:
        "Authing は OAuth2・ OIDC・ SAML・ LDAP などを介したあらゆるプロトコルをサポートしており、最小 6 行のコードで簡単にシングルサインオンできます。",
      "item-one": {
        title: "高い安全性",
        "list-one": "処理中にパスワードなし",
        "list-two": "Authing とドッキングアプリケーションの間で定期的にキーを回転させます。",
        "list-three": "中間者攻撃やリプレイ攻撃を効果的に防ぐために、トークンの故障メカニズムを採用します。",
        "list-four": "ユーザー ID 属性の詳細なマッピングと変換管理",
      },
      "item-two": {
        title: "Authing SDK は、インターフェースレスのアプリケーションや自社開発のシステムをサポートしています。",
        "list-one": "SAML、OIDC、CAS、OAuth などの国際標準プロトコルをサポートしています",
        "list-two": "人（グループ）ごとに異なるパスワードポリシーを設定します。",
        "list-three": "簡単な設定でアプリを使用できます。",
        "list-four": "Ding Talk、Tencent などのカスタム標準プロトコル（custom protocol）をサポートします。",
      },
      "item-three": {
        title: "主流の SaaS やオンプレミスの幅広いアプリケーションと事前に統合されています",
        "list-one":
          "Authing は、シングルサインオンインターフェースを持たないメーカーや自社開発システム向けの SDK を提供しています。",
        "list-two": "わずか5行のコードでシングルサインオンアクセスできます。",
      },
      "item-four": {
        title: "強力なアクセスポリシーエンジン",
        "list-one":
          "部門別、アプリケーション別、人員別、その他の属性別に適切なアクセス権セキュリティポリシーを必要に応じて設定し、安全性を高めます。",
        "list-two": "二次認証サービスを統合し、対応するセキュリティレベルを向上させます。",
        "list-three": "任意の数のセキュリティポリシーをサポートする",
      },
    },
  },
  ul: {
    0: " Guard は、低レベル認証の実装の詳細や面倒な UI 開発から開発者を守ります。",
    1: "ログインコンポーネント（Guard）は、ニーズに合わせて設定できる埋め込み型のログインフォームで、シングルページのアプリケーションにおすすめです。様々なソーシャルログインを簡単に追加できるので、ユーザーがシームレスにログインでき、プラットフォーム間で一貫したログイン体験を持つことができます。",
    2: "そのオプションにわずかな微調整を加えただけで、ほとんどのモダンなウェブサイトにフィットする美しいデザインを持っています。",
    3: "クロスプラットフォーム対応、すべてのプラットフォームでアクセス可能",
    4: "初期化には、フォーム全体の動作を制御する詳細なパラメータがあります。",
    5: "モバイ-ルパスワード、メール-パスワード、パスワード忘れ、パスワードリセットなどの煩雑で冗長な機能をサポートします。",
    6: "御社では、UI のデザイン要件や統一性に厳しい要求があります。",
    7: "貴社は既存の UI を変更したいと考えています。",
    8: "フロントエンド開発者が HTML、CSS、JavaScript でカスタマイズできるようになります。",
    9: "1954年5月に設立された高等教育出版社は、新中国で最も早い時期に設立された専門的な教育出版機関の一つです。 1700人以上のスタッフを擁し、年間1万冊以上の書籍を発行し、発行部数は1億3000万部。",
    10: "ユーザーログイン UI フォームコンポーネントを埋め込む - 統一認証 - 五行コードアクセスログインシステム - Authing",
    登录组件: "ログインコンポーネント",
    免费使用: "無料アクセス",
    查看文档: "ドキュメントを見る",
    什么是登录组件: "ログインコンポーネントとは？",
    登录组件接入效果: "ログインコンポーネントのアクセス効果",
    登录组件VS自定义UI: "ログインコンポーネント VS カスタム UI",
    Authing通用登录表单Guard: "Authing ユニバーサル ログイン フォーム Guard",
    由Authing保证安全的认证: "Authing によるセキュア認証",
    自定义UI: "カスタム UI",
    Whatis登录组件: "What is ログインコンポーネント?",
    前往社区: "コミュニティへ",
  },
  comp: {
    banner: {
      title: "通用登录组件",
      subtitle: "Guard は、低レベル認証の実装の詳細や面倒な UI 開発から開発者を守ります。",
    },
    comp: {
      title: "ログインコンポーネントとは？",
      descript:
        "ログインコンポーネント（Guard）は、ニーズに合わせて設定できる埋め込み型のログインフォームで、シングルページのアプリケーションにおすすめです。様々なソーシャルログインを簡単に追加できるので、ユーザーがシームレスにログインでき、プラットフォーム間で一貫したログイン体験を持つことができます。",
    },
    effect: {
      title: "ログインコンポーネントのアクセス効果",
    },
    compare: {
      title: "ログインコンポーネント VS カスタム UI",
      "item-one": {
        title: "Authing ユニバーサル ログイン フォーム Guard",
        "list-one":
          "そのオプションにわずかな微調整を加えただけで、ほとんどのモダンなウェブサイトにフィットする美しいデザインを持っています。",
        "list-two": "クロスプラットフォーム対応、すべてのプラットフォームでアクセス可能",
        "list-three": "初期化には、フォーム全体の動作を制御する詳細なパラメータがあります。",
        "list-four":
          "モバイ-ルパスワード、メール-パスワード、パスワード忘れ、パスワードリセットなどの煩雑で冗長な機能をサポートします。",
        "list-five": "Authing によるセキュア認証",
      },

      "item-two": {
        title: "カスタム UI",
        "list-one": "御社では、UI のデザイン要件や統一性に厳しい要求があります。",
        "list-two": "貴社は既存の UI を変更したいと考えています。",
        "list-three": "フロントエンド開発者が HTML、CSS、JavaScript でカスタマイズできるようになります。",
        "list-four": "Authing によるセキュア認証",
      },
    },
  },
};
